import { render, staticRenderFns } from "./MentoriasListaItem.vue?vue&type=template&id=8aaf4ba6&"
import script from "./MentoriasListaItem.vue?vue&type=script&lang=js&"
export * from "./MentoriasListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports